function StartSearchBusiness() {
    var displayType = $("input:radio[name=DisplayType]:checked").val();
//    var searchPrimary = $("input:checkbox[name=SearchPrimary]:checked").val();
    var searchPrimary = $("input:checkbox[name=SearchPrimary]").is("checked");
    SearchBusiness(displayType, searchPrimary);
}
function StartSearchBusiness2(tOmit) {
    var displayType = $("input:radio[name=DisplayType]:checked").val();
    //    var searchPrimary = $("input:checkbox[name=SearchPrimary]:checked").val();
    var searchPrimary = $("input:checkbox[name=SearchPrimary]").is("checked");
    SearchBusiness2(displayType, searchPrimary, tOmit);
}

// search industry / business by text
function SearchBusiness(type, searchPrimary) {
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    var searchType = $('#SearchType').val();
    $('#SearchText').val(keyword);
    $('#lnkIndustrySearch').hide();
    $('#divIndustrySearchLoadingimg').show();
    $.DotComAjax({
        url: "/UsBusiness/BusinessKeywordSearchItems?keyword=" + keyword + "&SearchType=" + searchType + "&DisplayType=" + type + "&primarySearch=" + searchPrimary,
        cache: true,
        success: function (data) {
            if (searchType == "BusinessName") {
                $('#helpCallDiv').hide();
                $('#BusinessSearchResults').html(data);
                $('#BusinessSearchResults').show();
                $('#IndustrySearchResults').hide();
            }
            else {
                $('#IndustrySearchResults').html(data);
                $('#IndustrySearchResults').show();
                $('#helpCallDiv').show();
                $('#BusinessSearchResults').hide();
            }
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
        },
        async: true
    });

}
// search industry / business by text
function SearchBusiness2(type, searchPrimary, tOmit) {
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    var searchType = $('#SearchType').val();
    $('#SearchText').val(keyword);
    $('#lnkIndustrySearch').hide();
    $('#divIndustrySearchLoadingimg').show();
    $.DotComAjax({
        url: "/UsBusiness/BusinessKeywordSearchItems?keyword=" + keyword + "&SearchType=" + searchType + "&DisplayType=" + type + "&primarySearch=" + searchPrimary + "&tOmit=" + tOmit,
        cache: true,
        success: function (data) {
            if (searchType == "BusinessName") {
                $('#helpCallDiv').hide();
                $('#BusinessSearchResults').html(data);
                $('#BusinessSearchResults').show();
                $('#IndustrySearchResults').hide();
            }
            else {
                $('#IndustrySearchResults').html(data);
                $('#IndustrySearchResults').show();
                $('#helpCallDiv').show();
                $('#BusinessSearchResults').hide();
            }
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divIndustrySearchLoadingimg').hide();
            $('#lnkIndustrySearch').show();
        },
        async: true
    });

}

// show or hide children
function HideShowBusinessSearchChildren(evt, name) {
    var key = evt.id;
    key = key.replace("img", "");
    if ($('#img' + key).attr('src') == '/Images/Common/plus_new.gif') {
        $('#img' + key).attr('src', '/Images/Common/minus_new.gif');
        $('#' + name + key).show();

    }
    else {
        $('#img' + key).attr('src', '/Images/Common/plus_new.gif');
        $('#' + name + key).hide();
    }

}

// select all or deselect all children
function BusinessSearchSelectAll(evt, name) {
    if ($('#' + name).val() == "False") {
        $('#BusinessSearchCategory' + name + ' input:checkbox').prop('checked', true);
        $('#' + name).val("true");
        $(evt).text("Deselect All");
    }
    else {
        $('#BusinessSearchCategory' + name + ' input:checkbox').prop('checked', false);
        $('#' + name).val("False");
        $(evt).text("Select All");
    }
    UpdateSelections();
    return false;
}


function ShowSelectedCodes(evt) {
    FadeOutSections();
    SearchBusiness($(evt).val());
}

function FadeOutSections() {
    $('#BusinessSearchResults').fadeOut('slow', function () {
    });
    $('#IndustrySearchResults').fadeOut('slow', function () {
    });
}


function ToggleSearch(search) {
    FadeOutSections();
    if (search == 'Business') {
        $('#DisplayCodesType').hide();
        $('#DisplayPrimarySearch').hide();
        $('#lnkBusiness').parent().removeClass('typeInactive');
        $('#lnkBusiness').parent().addClass('typeActive');
        $('#lnkIndustry').parent().removeClass('typeActive');
        $('#lnkIndustry').parent().addClass('typeInactive');
        $('#SearchType').val('BusinessName');
    }
    else {
        $('#DisplayCodesType').fadeIn('slow', function () { });
        $('#DisplayPrimarySearch').fadeIn('slow', function () { });
        $('#lnkBusiness').parent().removeClass('typeActive');
        $('#lnkBusiness').parent().addClass('typeInactive');
        $('#lnkIndustry').parent().removeClass('typeInactive');
        $('#lnkIndustry').parent().addClass('typeActive');
        $('#SearchType').val('IndustryType');
        $('#BusinessSearchCategoryRelated').show();
    }

    StartSearchBusiness();
}

function ShowRelatedResults() {
    $('#ShowRelatedResults').val(true);
    var keyword = $('#BusinessSearchText').val();
    if (keyword == '') {
        $('#helpCallDiv').hide();
        $('#BusinessSearchResults').hide();
        $('#IndustrySearchResults').hide();
        return;
    }
    if ($('#lnkIndustryRelated').html() == "Hide related results") {
        $('#BusinessSearchCategoryRelated').hide();
        $('#lnkIndustryRelated').html("Show related results");
        return;
    }
    var searchType = $('#SearchType').val();
    var topKeys = $('#TopKeys').val();
    var type = $("input:radio[name=DisplayType]:checked").val();
    $('#SearchText').val(keyword);
    $('#divLoadingimg').show();
    $('#BusinessSearchCategoryRelated');
    $.DotComAjax({
        url: "/UsBusiness/BusinessKeywordSearchRelatedResults",
        cache: true,
        type: 'POST',
        data: { keyword: keyword, searchType: searchType, displayType: type, topKeys: topKeys },
        success: function (data) {
            $('#BusinessSearchCategoryRelated').html(data);
            $('#BusinessSearchCategoryRelated').show();
            $('#divLoadingimg').hide();
            $('#lnkIndustryRelated').html("Hide related results");
            if (typeof success == 'function') {
                success();
            }
        },
        error: function () {
            context.find('img').attr('src', '/Images/Common/Exclamation.gif').attr('alt', 'Could not remove this selection');
            $('#divLoadingimg').hide();
        },
        async: true
    });
}

function CheckChildren(evt) {
    var id = evt.id.replace(/[#;&,%\.\+\*~':"!\^\$\[\]\(\)=>|\/\\]/g, '\\$&');

    $('#BusinessSearchItemChildren' + id + ' input:checkbox').prop('checked', $('#Header' + id + " input:checkbox").prop('checked'));
    var parentId = $('#' + id).parent().parent().attr('id');
    if (parentId == undefined || parentId == '') {
        UpdateSelections();
        return;
    }

    var childrenCount = $('#' + parentId + ' input:checkbox').length;
    var checkedChildrenCount = $('#' + parentId + ' input:checked').length;
    parentId = parentId.replace("BusinessSearchItemChildren", "");
    if (childrenCount == checkedChildrenCount)
        $('#' + parentId).prop('checked', true);
    else
        $('#' + parentId).prop('checked', false);

    UpdateSelections();
}

// Takes the contents of the serialized selections and reapplies the checkbox statuses
function ReapplySelections()
{
    var selectedSerializedString = $('#SerializedSelectedItems').val().split('~');
    for (var i = 0; i < selectedSerializedString.length; i++)
    {
        if (selectedSerializedString[i].length > 0)
        {
            var selectedItem = selectedSerializedString[i].split(':');
            var selectedItemId = selectedItem[0].replace(/(:|\.|\[|\]|,|=|@|&|'|")/g, "\\$1");
            if ($('#' + selectedItemId).length > 0)
                $('#' + selectedItemId)[0].checked = true;
        }
    }
}

function UpdateSelections() {
    var selectedSerializedString = $('#SerializedSelectedItems').val(),
        checkedSic = new Array(),
        uncheckedSic = new Array();

    $('#frmBusinessSearch .Expando input:checkbox').each(function (index, item) {
        var field = "~" + item.id + ":" + $(this).siblings("label").html();
        if ($(this).is(':checked')) {
            checkedSic.push(field);
        } else {
            uncheckedSic.push(field);
        }
    });

    for (var i = 0; i < uncheckedSic.length; i++)
    {
        if (selectedSerializedString.indexOf(uncheckedSic[i]) != -1) {
            selectedSerializedString = selectedSerializedString.replace(uncheckedSic[i], '');
        }
    }

    for (var j = 0; j < checkedSic.length; j++) {
        if (selectedSerializedString.indexOf(checkedSic[j]) == -1) {
            selectedSerializedString = selectedSerializedString + checkedSic[j];
        }
    }

    $('#SerializedSelectedItems').val(selectedSerializedString);
}

function objToString(object) {
    var str = '';
    for (var i in object) {
        str += "~" + object[i].key + ":" + object[i].value;
    }
    return str;
}

function clean(listArray, deleteValue) {
    for (var i = 0; i < listArray.length; i++) {
        if (listArray[i] == deleteValue) {
            listArray.splice(i, 1);
            i--;
        }
}
    return listArray;
};

